'use strict';

var React = require('react');

// https://www.totaltypescript.com/forwardref-with-generic-components
// eslint-disable-next-line @typescript-eslint/ban-types
function genericForwardRef(render) {
    return React.forwardRef(render);
}

exports.genericForwardRef = genericForwardRef;
//# sourceMappingURL=genericForwardRef.js.map
